<template>
  <div class="add_testpaper_wrap" >
    <div class="add_testpaper_title">
    	<div class="goback" @click="goBack">
				<img src="../../../../../static/images/course/icon-3.png"/>
				<span>返回</span>
			</div>
      <h2>{{titleExam}}</h2>
      <div class="btn">
        <el-button @click="saveTest">保存</el-button>
      </div>
    </div>
    <div class="add_testpaper_main" :style="'height:'+height">
      <el-form :model="testForm" ref="testForm" class="test_form">
        <el-form-item prop="examName" label="考试名称：">
          <el-input v-model.trim="testForm.examName" placeholder="请输入考试名称" type="text" maxlength="20" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="examTime" label="考试时长：">
          <el-input v-model.trim="testForm.examTime" type="text" autocomplete="off"></el-input><span>分钟</span>
        </el-form-item>
        <el-form-item label="考试时间：">
        	<el-date-picker
            v-model="testForm.classStartTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择开始时间"
            @change="changeEnd2"
            :picker-options="startDateLimit2">
          </el-date-picker>
          <span>——</span>
          <el-date-picker
	            v-model="testForm.classEndTime"
	            type="date"
	            @focus="changeEnd2"
	            @change="setTime2"
	            value-format="yyyy-MM-dd"
	            placeholder="请选择结束时间"
	            :picker-options="endDateLimit2">
	          </el-date-picker>
        </el-form-item>
        <el-form-item prop="answerSelect" label="答案公布：">
          <el-radio-group v-model="testForm.answerSelect">
            <el-radio :label="0">手动触发公布答案</el-radio>
            <el-radio :label="1">考试时间结束后自动公布答案</el-radio>
          </el-radio-group>
          <div style="margin-left: 90px;font-size: 12px;color: red;" v-if="testForm.answerSelect == 0">选择此项，等待学生交卷后，需要老师在外层点击“公布答案”，学生才可以看到参考答案及作答错误信息。</div>
        </el-form-item>
        <el-form-item label="教学班：">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
  				<div class="checkbox">
  					<el-checkbox-group v-model="checkedClass" @change="handleCheckedCitiesChange">
					    <el-checkbox v-for="item in classArr" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
					  </el-checkbox-group>
  				</div>
        </el-form-item>
      </el-form>
      <div class="select_test">
        <span>选择试卷：</span>
        <p @click="showTest()" v-if="JSON.stringify(this.testObj) == '{}'">
          <img src="../../../../../static/images/course/add.png" alt="">
        </p>
        <div class="testMsg" v-else>
        	<div class="imgBox">
        		<img src="../../../../../static/images/course/teachClassIcon/test.png"/>
        	</div>
        	<div class="right">
        		<li>{{testObj.paperName}}</li>
        		<li v-if="$route.query.paperId">{{testObj.paperScore}}分/{{testObj.count}}题</li>
        		<li v-else>{{testObj.totalScore}}分/{{testObj.questionCount}}题</li>
        		<li>
        			<el-button type="primary" icon="el-icon-view" @click="preview()">预览</el-button>
        			<el-button type="primary" v-if="!$route.query.paperId" icon="el-icon-delete" class="del" @click="del()">删除</el-button>
        		</li>
        	</div>
        </div>
      </div>
    </div>
    <!--选择试卷-->
		<el-drawer
		  title="选择试卷"
		  :visible.sync="drawer"
		  :direction="direction"
		  :close-on-press-escape="false"
		  :wrapperClosable="false"
		  :with-header="false">
		  <div class="drawer_content">
		  	<header>
		  		<span>选择试卷</span>
		  		<div class="btn">
		  			<el-button @click="cancelTestPaper">返回</el-button>
        		<el-button @click="saveTestPaper">保存</el-button>
		  		</div>
		  	</header>
		  	<div class="search_ipt">
					<h3 class="ipt">科目：{{subjectName}}</h3>
					<!-- <div class="ipt">
						<el-select v-model="subject" placeholder="请选择所属专业科目" v-if="subjectList.length>0" @change="change">
              <el-option
                v-for="item in subjectList"
                :key="item.id"
                :label="item.name"
                :title="item.name"
                :value="item.id">
              </el-option>
            </el-select>
					</div> -->
<!--		  		<div class="ipt">-->
<!--		  			<el-date-picker-->
<!--	            v-model="classStartTime"-->
<!--	            type="date"-->
<!--	            value-format="yyyy-MM-dd"-->
<!--	            placeholder="请选择开始时间"-->
<!--	            @change="changeEnd"-->
<!--	            :picker-options="startDateLimit">-->
<!--	          </el-date-picker>-->
<!--		  		</div>-->
<!--		  		<div class="ipt">-->
<!--		  			<el-date-picker-->
<!--	            v-model="classEndTime"-->
<!--	            type="date"-->
<!--	            @focus="changeEnd"-->
<!--	            @change="setTime"-->
<!--	            value-format="yyyy-MM-dd"-->
<!--	            placeholder="请选择结束时间"-->
<!--	            :picker-options="endDateLimit">-->
<!--	          </el-date-picker>-->
<!--		  		</div>-->
		  		<div class="ipt">
		  			<el-input class="ipt_name" v-model="testName" placeholder="请输入试卷名称"></el-input>
		  		</div>
		  		<div class="btn ipt">
		  			<el-button icon="el-icon-search" @click="search()">查询</el-button>
		  		</div>
		  	</div>
		  	<div class="table">
		  		<div class="header_title">
						<p></p>
						<p>试卷名称</p>
						<p>试卷用途</p>
						<p>总分/题</p>
						<p>创建时间</p>
					</div>
					<div class="teach_class" v-if="tableData.length>0">
						<li class="tab_item" v-for="(item,index) in tableData" :key="index">
							<p>
								<el-radio-group v-model="radio" @change="testChange">
							    <el-radio :label="item"><span></span></el-radio>
							  </el-radio-group>
							</p>
							<p>{{item.paperName}}</p>
							<p>{{item.paperType | filterStatus}}</p>
							<p>{{item.totalScore}}分/{{item.questionCount}}题</p>
							<p>{{item.createTime.substring(0,10)}}</p>
						</li>
					</div>
					<div v-else>
						<p style="font-size:14px;text-align:center;margin-top:20%;">该专业科目下暂无试卷</p>
					</div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageTotal.currentPage"
            background
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageTotal.pageSize"
            :pager-count="5"
            layout="sizes, prev, pager, next, jumper"
            :total="pageTotal.total"
            class="paginator"
            v-if="pageTotal.total>10"
          ></el-pagination>
		  	</div>
		  </div>
		</el-drawer>
		<!-- 试卷加密弹窗 -->
		<el-dialog title="输入密码" width="400px" :visible.sync="dialogFormVisible">
		  <el-form :model="passForm" :rules="passRules" ref="passForm">
		    <el-form-item label="密码" label-width="60px">
		      <el-input type="password" v-model="passForm.passwordUse" autocomplete="off"></el-input>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="passConfim('passForm')">确 定</el-button>
		  </div>
		</el-dialog>
  </div>
</template>
<script>
import * as api from '../../../../api/individualApi'
import * as courseApi from '../../../../api/courseApi'
import Pagination from "../../../paginator/paginator";
export default {
  components: {
    Pagination
  },
  data(){
    return{
    	height:window.innerHeight - 146+"px",
      loading: true,
      treeData: [],
      windowHeight: window.innerHeight,
      pageTotal: {//分页
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      testForm: {
        examName: '',
        examTime: '',
        classStartTime: '',
        classEndTime: '',
        answerSelect: 0,
        id:''
      },
      startDateLimit2:{
        disabledDate:(time)=>{
          if (this.testForm.classEndTime) {
            return time.getTime() > new Date(this.testForm.classEndTime).getTime();
          }else{//还没有选择结束时间的时候，让他只能选择今天之后的时间包括今天
            // return time.getTime() < Date.now() - 8.64e7
          } 
        }
      },
      endDateLimit2:null,
      selectFlag: true,
      answerTypeFlag: true,
      drawer: false,
      direction:'rtl',
      testName:'',
      startDateLimit:{
        disabledDate:(time)=>{
          if (this.classEndTime) {
            return time.getTime() > new Date(this.classEndTime).getTime();
          }else{//还没有选择结束时间的时候，让他只能选择今天之后的时间包括今天
            // return time.getTime() < Date.now() - 8.64e7
          } 
        }
      },
      endDateLimit:null,
      classStartTime:'',
      classEndTime:'',
      radio:'',
      tableData:[],
      subjectID: this.$route.query.subjectId,
      testObj:{},
      testObjs:{},
      isIndeterminate: false,
      checkAll: false,
      checkedClass: [],
      classArr: [],
      checkedList: [],
      titleExam: '添加考试',
			dialogFormVisible: false,
			passForm: {
				passwordUse: ''
			},
			passRules: {
				passwordUse: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],
			},
			subjectList:[],
			subject: "",
			subjectName: ''
    }
  },
  mounted(){
  	this.getList()
  	this.getAllTeachClass();
  	if(this.$route.query.paperId){
  		this.titleExam = '编辑考试';
  		this.getExamEcho();
  		this.getTestMsg();
  	}else{
  		this.titleExam = '添加考试';
  		this.testObj = {};
  	}
  },
  filters: {
    formatTime(time) {
      return (time = time.slice(0, 10) + " " + time.slice(11, 19));
    },
		filterStatus(paperType){
			let str = "";
			switch (paperType) {
				case 1:
						str = "考试";
						break;
				case 2:
						str = "测验";
						break;
				case 3:
						str = "大赛";
						break;
				case 4:
						str = "综合实训";
						break;
			}
			return str;
		}
  },
  methods:{
		getList(){//获取所有专业科目
			let that = this
			let id = sessionStorage.getItem('professional')
			courseApi.getSubjectList().then((rs)=>{
				if(rs.code==0){
					that.subjectList = []
					let obj = {}
					rs.data.forEach((item,i)=>{
						if(item.professionId == id){
							obj = {
								id: item.id,
								name: item.name,
								professionId: item.professionId
							}
							that.subjectList.push(obj)
						}
						if(this.subjectID == item.id){
							this.subjectName = item.name
						}
					})
					this.subject = Number(this.subjectID)
				}
			}).then(()=>{
				if(that.subjectList.length){
					this.getTestPaper(this.subjectID)
				}
			}).catch((error)=>{
				console.log(error)
			})
		},
		change(val){//选择科目
			this.pageTotal.currentPage = 1;
			this.subjectID = val
			this.getTestPaper(this.subjectID);
			this.radio = null;
			this.testObjs = {};
		},
  	// 获取所有的教学班
		getAllTeachClass(){
			let courseId = this.$route.query.courseId;
			api.getAllTeachClass(courseId).then(res=>{
				if(res.code == 0){
					this.classArr = res.data;
				}
			})
		},
		// 回显考试信息
		getExamEcho(){
			api.examEcho(this.$route.query.courseId,this.$route.query.paperId).then(res=>{
				console.log(res);
				if(res.code == 0){
					this.testForm = {
		        examName: res.data.examName,
		        examTime: res.data.examTime,
		        classStartTime: res.data.examStartTime,
		        classEndTime: res.data.examEndTime,
		        answerSelect: res.data.answerStatus,
		        id: res.data.id
		      }
					let list = res.data.examPaperClassRespList;
					let arr = [];
					list.forEach(val=>{
						arr.push(val.classId);
					});
					this.checkedList = arr;
					this.checkedClass = arr;
					if(this.classArr.length == this.checkedClass.length){
						this.isIndeterminate = false;
						this.checkAll = true;
					}else{
						this.isIndeterminate = true;
						this.checkAll = false;
					}
				}
			})
		},
		// 回显试卷信息
		getTestMsg(){
			api.getTestMsg(this.$route.query.paperId).then(res=>{
				console.log(res);
				if(res.code == 0){
					this.testObj = res.data
				}
			})
		},
  	// 获取试卷
  	getTestPaper(id){
      this.radio = ""
  		let obj = {
  			paperName: this.testName,
        subjectId: id,
        pageNo: this.pageTotal.currentPage,
        pageSize: this.pageTotal.pageSize,
        paperType: '1',
        status: 1
  		};
  		api.getPaperList(obj).then(res=>{
  			console.log(res);
  			if(res.code == 0){
  				this.tableData = res.data.testPaperList;
  				this.pageTotal.total = res.data.totalCount;
  			}
  		})
  	},
  	handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
			if(this.subjectList.length){
				this.getTestPaper(this.subjectID)
			}
   	},
   	handleSizeChange(val){
   		this.pageTotal.pageSize = val;
   		this.pageTotal.currentPage = 1;
      this.getTestPaper(this.subjectID);
   	},
    goBack(){
      this.$store.state.activeName = this.$route.query.index;
    	this.$router.go(-1);
    },
  	// 考试保存
  	saveTest(){
			console.log(this.testObj)
			if(!this.testForm.examName){
    		this.$messageError('请填写考试名称');
    		return
    	}
			if(!this.testForm.examTime){
    		this.$messageError('请填写考试时长');
    		return
      }
      var num = this.testForm.examTime;
      if (!(/(^[1-9]\d*$)/.test(num))) {
        this.$messageError('请填写正确的考试时长，考试时长为正整数');
        return
      }
      if(!this.testForm.classStartTime){
        this.$messageError('请填写考试开始时间');
    		return
      }
      if(!this.testForm.classEndTime){
        this.$messageError('请填写考试结束时间');
    		return
      }
    	if(JSON.stringify(this.testObj) == "{}"){
    		this.$messageError('请选择试卷');
    		return
    	}
    	if(this.$route.query.paperId){
    		let param = {
    			id: this.testForm.id,
	      	answerStatus: this.testForm.answerSelect,
	        courseId:this.$route.query.courseId,
	        classIdList:this.checkedList,
	        examName: this.testForm.examName,
	        examTime: this.testForm.examTime,
	        paperId: this.testObj.id,
	        examStartTime: this.testForm.classStartTime,
	        examEndTime: this.testForm.classEndTime
	      }
	    	api.editorExam(param).then(res=>{
	    		console.log(res);
	    		if(res.code == 0){
	    			this.$messageSuccess('编辑考试成功');
						this.$router.go(-1);
	    		}else{
	    			this.$messageError(res.msg);
	    		}
	    	})
    	}else{
    		let param = {
	      	answerStatus: this.testForm.answerSelect,
	        courseId:this.$route.query.courseId,
	        classIdList:this.checkedList,
	        examName: this.testForm.examName,
	        examTime: this.testForm.examTime,
	        paperId: this.testObj.id,
	        subjectId: this.testObj.subjectId,
	        examStartTime: this.testForm.classStartTime,
	        examEndTime: this.testForm.classEndTime
	      }
	    	api.addExam(param).then(res=>{
	    		if(res.code == 0){
	    			this.$messageSuccess('添加考试成功');
						this.$router.go(-1);
						api.checkPaperDecryption(this.testObj.paperCode).then(res=>{
							if(res.code == 0 && res.data){
								let obj = {
									"paperId": this.testObj.id,
									"operationContent": "使用了试卷"
								}
								api.addPaperOperationRecord(obj);
							}
						})
	    		}else{
	    			this.$messageError(res.msg);
	    		}
	    	})
    	}
  	},
  	// 选择试卷
  	showTest(){
  		this.drawer = true;
  		this.radio = null;
  		this.testObjs = {};
			this.subject = Number(this.$route.query.subjectId);
			this.getList();
  	},
  	// 删除试卷
  	del(){
  		this.testObj = {};
  	},
  	// 预览试卷
  	preview(){
  		let paperId = ''
  		if(this.testObj.id){
  			paperId = this.testObj.id;
  		}else{
  			paperId = this.$route.query.paperId;
  		}
  		const { href } = this.$router.resolve({
        path: '/switch/test/preview',
        query: {
          paperId: paperId,
          id: this.$route.query.courseId
        }
      });
      window.open(href, '_blank');
  	},
  	cancelTestPaper(){
  		this.drawer = false;
  	},
  	// 保存试卷
  	saveTestPaper(){
			console.log(this.testObjs)
  		if(JSON.stringify(this.testObjs) != "{}" ){
				api.checkPaperDecryption(this.testObjs.paperCode).then(res=>{
					if(res.code == 0){
						if(res.data){
							this.dialogFormVisible = true;
							this.passForm.passwordUse = ''
						}else{
							this.testObj = this.testObjs;
							this.drawer = false;
						}
					}
				})
  		}else{
  			this.$message.warning('请先选择要保存的试卷')
  		}
  	},
		// 试卷解密
		passConfim(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let param = {
						"paperCode": this.testObjs.paperCode,
						"passwordUse": this.passForm.passwordUse
					}
					api.usePaperDecryption(param).then(res=>{
						if(res.code == 0 && res.data){
							this.testObj = this.testObjs;
							this.drawer = false;
							this.dialogFormVisible = false;
						}else{
							this.$messageError('密码错误，请重新输入');
							this.passForm.passwordUse = ''
						}
					})
				}
			});
		},
  	search(){
      this.handleCurrentChange(1)
  	},
  	testChange(val){
  		this.testObjs = val;
  	},
  	handleCheckAllChange(val) {
	  	if(val){
	  		this.checkedClass = [];
	  		this.classArr.forEach(item=>{
          this.checkedClass.push(item.id);
        })
	  	}else{
	  		this.checkAll = false;
        this.checkedClass = [];
	  	}
	  	this.checkedList = this.checkedClass;
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.classArr.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.classArr.length;
      this.checkedList = value;
    },
  	//time
    changeEnd(){
      //如果结束日期尚未选择
      if(!this.classStartTime){
        this.$message.warning('请先选择开始日期')
        this.endDateLimit = Object.assign({},this.endDateLimit,{
          disabledDate:(date)=>{
            return true
          }
        })
      }else{
        this.endDateLimit = Object.assign({},this.endDateLimit,{
          disabledDate: (time) => {
            if(this.classStartTime){
              return time.getTime() < new Date(this.classStartTime).getTime() - 1*24*60*60*1000;//可以选择同一天
            }
          }
        })
      }
    },
    setTime(){
      if(this.classEndTime){
        if(this.classStartTime > this.classEndTime){
          this.classEndTime = ''
          this.$message.warning('结束日期小于开始日期，请重新选择')
          return ;
        }
      }
    },
    changeEnd2(){
      //如果结束日期尚未选择
      if(!this.testForm.classStartTime){
        this.$message.warning('请先选择开始日期')
        this.endDateLimit2 = Object.assign({},this.endDateLimit2,{
          disabledDate:(date)=>{
            return true
          }
        })
      }else{
        this.endDateLimit2 = Object.assign({},this.endDateLimit2,{
          disabledDate: (time) => {
            if(this.testForm.classStartTime){
              return time.getTime() < new Date(this.testForm.classStartTime).getTime() - 1*24*60*60*1000;//可以选择同一天
            }
          }
        })
      }
    },
    setTime2(){
      if(this.testForm.classEndTime){
        if(this.testForm.classStartTime > this.testForm.classEndTime){
          this.testForm.classEndTime = ''
          this.$message.warning('结束日期小于开始日期，请重新选择')
          return ;
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .add_testpaper_wrap{
    background: #fff;
    padding: 0 16px;
    margin: 16px 16px 0;
    border-radius: 4px;
    .add_testpaper_title{
      height: 52px;
      border-bottom: 1px solid #DDE0E2;
      position: relative;
      h2{
        font-size:16px;
        font-weight:bold;
        color:rgba(13,13,13,1);
        position: relative;
        line-height: 64px;
        margin-left: 82px;
      }
      .goback {
      	position: absolute;
				display: flex;
				align-items: center;
				cursor: pointer;
				top: 21px;
				img {
					display: inline-block;
					width: 18px;
					height: 18px;
				}
				span {
					font-size: 14px;
					padding: 0 8px;
					color: #858C96;
				}
				&::after{
          content:'';
          position: absolute;
          left: 66px;
          top: 5px;
          background: #5397F7;
          width: 4px;
          height: 12px;
        }
			}
      .btn{
        position: absolute;
        right: 0;
        top: 17px;
        button{
          width:72px;
          height:28px;
          background:rgba(83,151,247,1);
          border-radius:4px;
          color: #fff;
          padding: 0;
          font-size: 12px;
          &:hover{
            opacity: 0.8;
          }
          &:last-child{
            margin-left: 12px;
          }
        }
      }
    }
    .add_testpaper_main{
      padding: 16px;
      box-sizing: border-box;
      overflow-y: auto;
      /deep/ .test_form{
        border-bottom: 1px solid #DDE0E2;
        margin-right: 16px;
        .el-form-item{
        	margin-bottom: 15px;
          .el-form-item__label{
            font-size:12px;
            font-weight:400;
            line-height:28px;
            color:rgba(13,13,13,1);
            letter-spacing: 1px;
          }
          .el-form-item__content{
            line-height: 28px;
            .el-input{
              .el-input__inner{
                height: 28px;
                line-height: 28px;
                border: 0;
                background: #F1F2F4;
								border-radius: 2px;
              }
            }
          }
          &:nth-child(1) {
          	.el-input{
          		width: 320px;
          	}
          }
          &:nth-child(2) {
          	.el-input{
          		width: 140px;
          	}
          	span {
          		margin-left: 8px;
          	}
          }
          &:nth-child(3) {
          	.el-input__icon {
          		line-height: 25px;
          	}
          }
          .checkbox {
          	width: 60%;
          	margin-left: 52px;
						height: 179px;
						background: #F1F2F4;
						border-radius: 4px;
						overflow: auto;
						.el-checkbox-group {
							height: 150px;
							padding: 12px;
							display: flex;
					    flex-flow: column;
					    flex-wrap: wrap;
							.el-checkbox {
								/deep/ .el-checkbox__label {
									font-size: 12px;
								}
							}
						}
					}
        }
      }
      .select_test{
        display: flex;
        margin-right: 16px;
        margin-top: 16px;
        span{
          min-width: 90px;
          line-height: 28px;
          font-size:12px;
          font-weight:400;
          color:rgba(13,13,13,1);
          letter-spacing: 1px;
          text-align: right;
          padding-right: 10px;
          box-sizing: border-box;
        }
        p{
          width:120px;
          height:112px;
          background:rgba(241,242,244,1);
          border-radius:3px;
          position: relative;
          cursor: pointer;
          img{
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 35px;
            height: 35px;
          }
        }
      }
      .testMsg {
      	display: flex;
      	justify-content: space-between;
      	.imgBox {
      		width: 120px;
      		height: 112px;
      		background: #5397F7;
      		display: flex;
      		align-items: center;
      		justify-content: center;
      		border-radius: 3px;
      		img {
      			display: inline-block;
      			width: 65px;
      			height: 65px;
      			margin-left: 14px;
      		}
      	}
      	.right {
      		margin-left: 14px;
      		li {
      			&:nth-child(1) {
      				color: #0D141E;
      				font-size: 14px;
      			}
      			&:nth-child(2) {
      				color: #858C96;
      				font-size: 12px;
      				margin: 16px 0;
      			}
      			&:nth-child(3) {
      				.el-button {
      					padding: 7px 8px;
      					background: #5397F7;
      					border: 0;
      					/deep/ .el-icon-view,/deep/ .el-icon-delete {
      						color: #fff;
      					}
      				}
      				.del {
      					background: #F77981;
      				}
      			}
      		}
      	}
      }
    }
    /deep/ .el-drawer {
			width: 80% !important;
		}
		.drawer_content {
			header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 64px;
				border-bottom: 1px solid #DDE0E2;
				padding: 0 20px;
				span {
					font-size: 16px;
					color: #0D0D0D;
					font-weight: bold;
				}
				img {
					display: block;
					width: 26px;
					height: 26px;
					cursor: pointer;
				}
				.btn {
					.el-button {
						padding: 7px 23px;
						background: #5397F7;
						color: #fff;
					}
				}
			}
			.search_ipt {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				margin-top: 14px;
				padding-left: 37px;
				h3 {
					font-size: 12px;
					color: #0D141E;
					font-weight: bold;
				}
				.ipt {
					margin-right: 20px;
					/deep/ .el-input {
						width: 190px;
						.el-input__inner {
							height: 28px;
							line-height: 28px;
							border: 0;
							background: #F1F2F4;
						}
						.el-input__icon {
							line-height: 28px;
						}
					}
				}
				.btn {
					.el-button {
						background: #5397F7;
						color: #fff;
						padding: 7px 14px;
					}
				}
			}
			.table {
				margin-top: 12px;
				padding: 0 24px;
				overflow-y: auto;
				.header_title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					p {
						font-size:12px;
	          color:rgba(93,100,110,1);
	          text-align: left;
	          &:nth-child(1){ width: 60px; }
	          &:nth-child(2){ flex: 1; padding: 0 16px; box-sizing: border-box; }
	          &:nth-child(3){ width: 15%; }
	          &:nth-child(4){ width: 15%; }
	          &:nth-child(5){ width: 20%; }
					}
				}
				.teach_class {
					.tab_item {
						display: flex;
						align-items: center;
						justify-content: space-between;
						height:40px;
						background:rgba(246,248,251,1);
						border-radius:4px;
						margin: 8px 0;
						&:hover {
							background: #E9EEF5;
						}
						p {
							font-size:12px;
		          color: #0D141E;
		          text-align: left;
		          &:nth-child(1){ width: 60px; text-align: center;}
		          &:nth-child(2){ flex: 1; padding: 0 16px; box-sizing: border-box; }
		          &:nth-child(3){ width: 15%; }
		          &:nth-child(4){ width: 15%; }
		          &:nth-child(5){ width: 20%; }
						}
					}
				}
			}
		}
  }
</style>



// WEBPACK FOOTER //
// src/components/views/TeachClass/components/addExam.vue